@if (checking()) {
  <wpp-piston-loader size="15rem" centered />
} @else {
  <core-ui-row class="mb-5 appointment-row" [justify]="'center'">
    <core-ui-card
      class="appointment-card appointment-card--narrow"
      [title]="'wpp.common.appointment.plan-title' | translate"
    >
      <core-ui-text>
        {{ 'wpp.page.start.intro' | translate }}
      </core-ui-text>

      <form [formGroup]="startForm" class="d-flex flex-column mt-5">
        <core-ui-form-group>
          <core-ui-email-input
            [hasError]="startForm.get('email')?.invalid && submitted"
            [placeholder]="'wpp.common.label.email' | translate"
            formControlName="email"
          />
          @if (startForm.get('email')?.invalid && submitted) {
            <core-ui-validation-feedback
              [message]="'wpp.common.validation.email-invalid' | translate"
            />
          }
        </core-ui-form-group>
        <core-ui-form-group>
          <div class="d-flex">
            <core-ui-checkbox formControlName="agree" />
            <div>
              {{ 'wpp.page.start.consent.prefix' | translate }}
              <core-ui-link [link]="config()?.termsAndConditions">
                {{ 'wpp.page.start.consent.terms-link' | translate }}
              </core-ui-link>
              {{ 'wpp.page.start.consent.separator' | translate }}
              <core-ui-link [link]="config()?.privacyStatement">
                {{ 'wpp.page.start.consent.privacy-link' | translate }}
              </core-ui-link>
            </div>
          </div>
          @if (startForm.get('agree')?.invalid && submitted) {
            <core-ui-validation-feedback
              [message]="'wpp.page.start.validation.agree-required' | translate"
            />
          }
        </core-ui-form-group>
      </form>
      <core-ui-row card-footer>
        <core-ui-button class="mt-auto" buttonStyle="secondary" (buttonClick)="onSubmit()">
          {{ 'wpp.common.action.next' | translate }}
          <core-ui-icon class="ms-2" icon="arrow-right" />
        </core-ui-button>
      </core-ui-row>
    </core-ui-card>
  </core-ui-row>
}
